module.exports = __webpack_public_path__ + "static/img/logo.9b60a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 273
// module chunks = 1